export const MonthsLabels = {
  0: 'CALENDAR.JANUARY',
  1: 'CALENDAR.FEBRUARY',
  2: 'CALENDAR.MARCH',
  3: 'CALENDAR.APRIL',
  4: 'CALENDAR.MAY',
  5: 'CALENDAR.JUNE',
  6: 'CALENDAR.JULY',
  7: 'CALENDAR.AUGUST',
  8: 'CALENDAR.SEPTEMBER',
  9: 'CALENDAR.OCTOBER',
  10: 'CALENDAR.NOVEMBER',
  11: 'CALENDAR.DECEMBER'
};

export const MonthsAbrvLabels = {
  0: 'CALENDAR.JANUARY_ABRV',
  1: 'CALENDAR.FEBRUARY_ABRV',
  2: 'CALENDAR.MARCH_ABRV',
  3: 'CALENDAR.APRIL_ABRV',
  4: 'CALENDAR.MAY_ABRV',
  5: 'CALENDAR.JUNE_ABRV',
  6: 'CALENDAR.JULY_ABRV',
  7: 'CALENDAR.AUGUST_ABRV',
  8: 'CALENDAR.SEPTEMBER_ABRV',
  9: 'CALENDAR.OCTOBER_ABRV',
  10: 'CALENDAR.NOVEMBER_ABRV',
  11: 'CALENDAR.DECEMBER_ABRV'
};
